<template>
    <RowButton
        class="burger__button"
        :class="{'active':props.activeClass}"
    >
        <slot>
            <span class="burger__button-line" />
            <span class="burger__button-line" />
            <span class="burger__button-line" />
        </slot>
    </RowButton>
</template>

<script>
export default {
    name: 'BurgerButton',
};
</script>

<script setup>
import RowButton from '@/components/ui/buttons/RowButton';

const props = defineProps({
    activeClass: { type: Boolean },
});
</script>

<style src="./styles.scss" lang="scss" scoped />
